import { render, staticRenderFns } from "./SubLevel.vue?vue&type=template&id=03bfaa3e&scoped=true&"
import script from "./SubLevel.vue?vue&type=script&lang=js&"
export * from "./SubLevel.vue?vue&type=script&lang=js&"
import style0 from "./SubLevel.vue?vue&type=style&index=0&id=03bfaa3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bfaa3e",
  null
  
)

export default component.exports